import { Watch } from "@material-ui/icons";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { fieldDragStart } from "@syncfusion/ej2-pivotview";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { isEditState } from "../../VendorInvoice/InvoiceCapture/atoms/atoms";
import { useRecoilValue } from "recoil";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

interface VendorAddressProps {
  isUtilitiesType: boolean;
  isApprover: boolean;
  isEdit: boolean;
}

const VendorAddress: React.FC<VendorAddressProps> = ({
  isUtilitiesType,
  isApprover,
  isEdit,
}) => {
  const user = useRecoilValue(accountAtom);
  const [searchBox, setSearchBox] = useState<any>(null);
  const formMethods = useFormContext();

  type Library = (
    | "places"
    | "drawing"
    | "geometry"
    | "localContext"
    | "visualization"
  )[];

  const {
    formState: { errors },
  } = formMethods;

  const libraries: Library = ["places"];

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: user?.googleApiKey ? user?.googleApiKey : "",
    libraries,
  });

  const onLoad = (ref) => {
    setSearchBox(ref);
  };

  const clearAddress = () => {
    formMethods.setValue("state", "");
    formMethods.setValue("city", "");
    formMethods.setValue("zipCode", "");
    formMethods.setValue("street", "");
    formMethods.setValue("locationLatitude", "");
    formMethods.setValue("locationLongitude", "");
    formMethods.setValue("physicalLocation", "");
    formMethods.setValue("street_number", "");
    formMethods.setValue("route", "");
  };

  const OnPlacesChanged = () => {
    const place = searchBox?.getPlace();
    clearAddress();
    if (place.address_components) {
      place.address_components.forEach((place) => {
        const addressType = place.types[0];
        switch (addressType) {
          case "administrative_area_level_1":
            formMethods.setValue("state", place.short_name);
            break;
          case "locality":
            formMethods.setValue("city", place.long_name);
            break;
          case "postal_code":
            formMethods.setValue("zipCode", place.short_name);
            break;
          case "route":
            formMethods.setValue("route", place.short_name);
            break;
          case "street_number":
            formMethods.setValue("street_number", place.short_name);
            break;
          case "country":
            formMethods.setValue("country", place.short_name);
            break;
        }
      });
      formMethods.setValue(
        "street",
        (formMethods.watch("street_number")
          ? formMethods.watch("street_number") + " "
          : "") + (formMethods.watch("route") ? formMethods.watch("route") : "")
      );
    }
    const locLattitude = place.geometry?.location?.lat();
    const locLongitude = place.geometry?.location?.lng();
    formMethods.setValue("locationLatitude", locLattitude);
    formMethods.setValue("locationLongitude", locLongitude);
    formMethods.setValue("physicalLocation", place.formatted_address);
  };

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Address Information
      </div>
      <div className="grid grid-cols-2 md:grid-cols-2 mx-4 mr-5 pb-2 gap-12">
        {isLoaded && (
          <>
            <div className="space-y-1 mr-6">
              <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                  <div className="text-red-500 pr-0.5 font-bold">*</div>
                  Address:
                </label>
                <div className="col-span-2">
                  <Controller
                    control={formMethods.control}
                    name="physicalLocation"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Autocomplete
                        onLoad={onLoad}
                        onPlaceChanged={OnPlacesChanged}
                        restrictions={{ country: "us" }}
                      >
                        <input
                          {...field}
                          onChange={(e: any) => {
                            field.onChange(e.target.value);
                            if (!e.target.value) {
                              clearAddress();
                            }
                          }}
                          type="text"
                          value={field.value}
                          placeholder="Enter Location"
                          className={
                            formMethods.formState.errors.physicalLocation
                              ? "border-2 border-red-500 focus:ring-septenary focus:border-septenar block w-full text-xs p-1 bg-white bg-clip-padding leading-normal outline-none block w-full "
                              : "border border-gray-300 focus:ring-septenary focus:border-septenar block w-full text-xs p-1 bg-white bg-clip-padding leading-normal outline-none block w-full "
                          }
                          disabled={isUtilitiesType && !isApprover && isEdit}
                        />
                      </Autocomplete>
                    )}
                  />
                </div>
              </div>
              <TextInputLabelHookForm
                label="Street"
                disabled={true}
                register={formMethods.register("street", {})}
              />
              <TextInputLabelHookForm
                label="City"
                disabled={true}
                register={formMethods.register("city", {})}
              />
              <TextInputLabelHookForm
                label="State"
                disabled={true}
                register={formMethods.register("state", {})}
              />
              <TextInputLabelHookForm
                label="Zip Code"
                disabled={true}
                register={formMethods.register("zipCode", {})}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default VendorAddress;
